import { Col, Row, Table } from "react-bootstrap";
import usePageTitle from "common/usePageTitle";

function PodukePricePage() {
  usePageTitle("Cjenik poduka");

  return (
    <div>
      <h1 className="mb-5">Cjenik poduka</h1>

      <Row>
        <Col md={10} lg={8} xxl={6}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Trajanje</th>
                <th>Cijena</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>60 minuta</td>
                <td>20 €</td>
              </tr>
              <tr>
                <td>90 minuta</td>
                <td>30 €</td>
              </tr>
              <tr>
                <td>120 minuta</td>
                <td>40 €</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <p>
        <em>U cijenu je uračunat iznos PDV-a. Mogućnost plaćanja na rate.</em>
      </p>
    </div>
  );
}

export default PodukePricePage;
